export enum RouteName {
  ROOT = "/",
  NOTETABLE = "/notes/:unicId",
  LOGIN = "/login",
  ADMIN_ADD_INSTANCE = "/system-admin/add/instance",
  ADMIN_VIEW_INSTANCE = "/system-admin/view/instance",
}
